var render, staticRenderFns
import script from "./TrainingBasketButton.vue?vue&type=script&lang=js"
export * from "./TrainingBasketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5d9e7d')) {
      api.createRecord('0c5d9e7d', component.options)
    } else {
      api.reload('0c5d9e7d', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/TrainingBasketButton.vue"
export default component.exports